(function () {
  function normalizeText(value) {
    return (value || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");
  }

  // ==========================
  // FALLBACK LOGO COLOR (from Liquid JSON)
  // ==========================
  function getLogoFallbackColor(sectionId) {
    const scriptEl = document.getElementById(`ProductLogoColorFallback-${sectionId}`);
    if (!scriptEl) return null;

    try {
      return JSON.parse(scriptEl.textContent);
    } catch (err) {
      console.warn("ProductLogoColorFallback JSON inválido", err);
      return null;
    }
  }

  // ==========================
  // VARIANT META MAP (by selected variant id) -> for logo priority
  // ==========================
  function getVariantSwatchMetaMap(sectionId) {
    const scriptEl = document.getElementById(`VariantSwatchMetaMap-${sectionId}`);
    if (!scriptEl) return null;

    try {
      const parsed = JSON.parse(scriptEl.textContent);
      return parsed && typeof parsed === "object" ? parsed : null;
    } catch (err) {
      console.warn("VariantSwatchMetaMap JSON inválido", err);
      return null;
    }
  }

  function getSelectedVariantId(productInfoEl) {
    // 1) Input hidden del product form (más confiable en Dawn)
    const hiddenVariantInput = productInfoEl.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (hiddenVariantInput && hiddenVariantInput.value) return String(hiddenVariantInput.value);

    // 2) Variant-selects JSON seleccionado (fallback)
    const selectedVariantScript = productInfoEl.querySelector('variant-selects script[data-selected-variant]');
    if (selectedVariantScript) {
      try {
        const variantObj = JSON.parse(selectedVariantScript.textContent);
        if (variantObj && variantObj.id) return String(variantObj.id);
      } catch (e) {}
    }

    // 3) URL ?variant=
    try {
      const params = new URLSearchParams(window.location.search);
      const variantFromUrl = params.get("variant");
      if (variantFromUrl) return String(variantFromUrl);
    } catch (e) {}

    return null;
  }

  function getSelectedVariantSwatchMeta(productInfoEl) {
    const sectionId = productInfoEl.dataset.section;
    if (!sectionId) return null;

    const selectedVariantId = getSelectedVariantId(productInfoEl);
    if (!selectedVariantId) return null;

    const map = getVariantSwatchMetaMap(sectionId);
    if (!map) return null;

    const meta = map[selectedVariantId];
    return meta && typeof meta === "object" ? meta : null;
  }

  // ==========================
  // COLOR SWATCH META MAP (by color option text) -> for painting swatches
  // ==========================
  function getColorSwatchMetaMap(sectionId) {
    const scriptEl = document.getElementById(`ColorSwatchMetaMap-${sectionId}`);
    if (!scriptEl) return null;

    try {
      const parsed = JSON.parse(scriptEl.textContent);
      return parsed && typeof parsed === "object" ? parsed : null;
    } catch (err) {
      console.warn("ColorSwatchMetaMap JSON inválido", err);
      return null;
    }
  }

  // ==========================
  // COLOR FIELDSET / SWATCH READERS
  // ==========================
  function getSelectedColorFieldset(productInfoEl) {
    const fieldsets = productInfoEl.querySelectorAll("fieldset.js.product-form__input");
    for (const fieldset of fieldsets) {
      const legendText = fieldset.querySelector("legend")?.textContent || "";
      const normalizedLegend = normalizeText(legendText);

      if (normalizedLegend.includes("color") || normalizedLegend.includes("colour")) {
        return fieldset;
      }
    }
    return null;
  }

  function getSelectedSwatchBackground(productInfoEl) {
    const colorFieldset = getSelectedColorFieldset(productInfoEl);
    if (!colorFieldset) return null;

    // Radios
    const checkedRadio = colorFieldset.querySelector('input[type="radio"]:checked');
    if (checkedRadio) {
      let label = checkedRadio.id
        ? colorFieldset.querySelector(`label[for="${checkedRadio.id}"]`)
        : null;

      if (!label) label = checkedRadio.closest("label");
      if (!label) return null;

      const swatchEl = label.querySelector(".swatch");
      if (!swatchEl) return null;

      if (swatchEl.style && swatchEl.style.background) {
        return swatchEl.style.background.trim();
      }

      const computed = window.getComputedStyle(swatchEl);
      if (computed.backgroundImage && computed.backgroundImage !== "none") {
        return computed.backgroundImage.trim();
      }
      if (
        computed.backgroundColor &&
        computed.backgroundColor !== "rgba(0, 0, 0, 0)" &&
        computed.backgroundColor !== "transparent"
      ) {
        return computed.backgroundColor.trim();
      }
    }

    // Dropdown swatch
    const select = colorFieldset.querySelector("select");
    if (select) {
      const swatchEl =
        colorFieldset.querySelector(".dropdown-swatch .swatch") ||
        colorFieldset.querySelector(".dropdown-swatch");

      if (swatchEl) {
        if (swatchEl.style && swatchEl.style.background) {
          return swatchEl.style.background.trim();
        }

        const computed = window.getComputedStyle(swatchEl);
        if (computed.backgroundImage && computed.backgroundImage !== "none") {
          return computed.backgroundImage.trim();
        }
        if (
          computed.backgroundColor &&
          computed.backgroundColor !== "rgba(0, 0, 0, 0)" &&
          computed.backgroundColor !== "transparent"
        ) {
          return computed.backgroundColor.trim();
        }
      }
    }

    return null;
  }

  // ==========================
  // SWATCH BACKGROUND BUILDERS
  // ==========================
  function buildSwatchCssBackgroundFromMeta(meta) {
    if (!meta || !meta.color || !meta.color.rgb) return null;

    const first = String(meta.color.rgb).trim();
    const second = meta.color.second_rgb ? String(meta.color.second_rgb).trim() : "";

    if (second) {
      return `linear-gradient(45deg, rgb(${first}) 50%, rgb(${second}) 50%)`;
    }

    return `rgb(${first})`;
  }

  // Nuevo: pintar TODOS los swatches de color (no solo el seleccionado)
  function applyCustomGradientToAllColorSwatches(productInfoEl) {
    const sectionId = productInfoEl.dataset.section;
    if (!sectionId) return;

    const colorFieldset = getSelectedColorFieldset(productInfoEl);
    if (!colorFieldset) return;

    const colorMap = getColorSwatchMetaMap(sectionId);
    if (!colorMap) return;

    // ---- Caso radios (swatches tipo botones)
    const radios = colorFieldset.querySelectorAll('input[type="radio"]');
    if (radios.length) {
      radios.forEach((radio) => {
        const optionValue = (radio.value || "").trim();

        let label = radio.id ? colorFieldset.querySelector(`label[for="${radio.id}"]`) : null;
        if (!label) label = radio.closest("label");
        if (!label) return;

        const swatchEl = label.querySelector(".swatch");
        if (!swatchEl) return;

        // Guardar fondo original una sola vez (Shopify)
        if (swatchEl.dataset.originalBackground == null) {
          swatchEl.dataset.originalBackground = swatchEl.style.background || "";
        }

        const metaColor = colorMap[optionValue];
        const customBg = buildSwatchCssBackgroundFromMeta(metaColor ? { color: metaColor } : null);

        if (customBg) {
          swatchEl.style.background = customBg;
          swatchEl.dataset.customGradientApplied = "true";
        } else {
          swatchEl.style.background = swatchEl.dataset.originalBackground;
          swatchEl.dataset.customGradientApplied = "false";
        }
      });
    }

    // ---- Caso dropdown con swatch visual (solo pinta el seleccionado)
    const select = colorFieldset.querySelector("select");
    if (select) {
      const dropdownSwatch =
        colorFieldset.querySelector(".dropdown-swatch .swatch") ||
        colorFieldset.querySelector(".dropdown-swatch");

      if (dropdownSwatch) {
        if (dropdownSwatch.dataset.originalBackground == null) {
          dropdownSwatch.dataset.originalBackground = dropdownSwatch.style.background || "";
        }

        const selectedValue = (select.value || "").trim();
        const metaColor = colorMap[selectedValue];
        const customBg = buildSwatchCssBackgroundFromMeta(metaColor ? { color: metaColor } : null);

        if (customBg) {
          dropdownSwatch.style.background = customBg;
          dropdownSwatch.dataset.customGradientApplied = "true";
        } else {
          dropdownSwatch.style.background = dropdownSwatch.dataset.originalBackground;
          dropdownSwatch.dataset.customGradientApplied = "false";
        }
      }
    }
  }

  // ==========================
  // COLOR NORMALIZERS FOR LOGO
  // ==========================
  function rgbStringToHex(rgbString) {
    const match = rgbString && rgbString.match(/rgba?\((\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
    if (!match) return null;

    const r = Number.parseInt(match[1], 10);
    const g = Number.parseInt(match[2], 10);
    const b = Number.parseInt(match[3], 10);

    const toHex = (n) => n.toString(16).padStart(2, "0");
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }

  /**
   * Convierte:
   * - "rgb(1,2,3)" => "#010203"
   * - "linear-gradient(... rgb(...) ..., rgb(...) ...)" => "#hex1,#hex2"
   * - "#abc" / "#aabbcc" => igual
   * - "hex1,hex2" => igual
   */
  function normalizeSwatchBackgroundForLogo(input) {
    if (!input || typeof input !== "string") return null;

    const value = input.trim();

    if (
      value.includes(",") &&
      !value.toLowerCase().includes("rgb(") &&
      !value.toLowerCase().includes("linear-gradient")
    ) {
      return value;
    }

    if (value.startsWith("#")) {
      return value;
    }

    if (value.toLowerCase().startsWith("rgb(") || value.toLowerCase().startsWith("rgba(")) {
      return rgbStringToHex(value);
    }

    if (value.toLowerCase().includes("linear-gradient")) {
      const rgbMatches = value.match(/rgba?\([^)]+\)/gi) || [];
      if (rgbMatches.length >= 2) {
        const c1 = rgbStringToHex(rgbMatches[0]);
        const c2 = rgbStringToHex(rgbMatches[1]);
        if (c1 && c2) return `${c1},${c2}`;
      } else if (rgbMatches.length === 1) {
        return rgbStringToHex(rgbMatches[0]);
      }
    }

    return null;
  }

  function updateLogoColorWithVariantFallback(productInfoEl) {
    const sectionId = productInfoEl.dataset.section;
    if (!sectionId) return;

    let logoColor = null;

    // 1) PRIORIDAD: metafield custom de la variante seleccionada (estable)
    const selectedVariantMeta = getSelectedVariantSwatchMeta(productInfoEl);
    if (selectedVariantMeta) {
      const customBg = buildSwatchCssBackgroundFromMeta(selectedVariantMeta);
      logoColor = normalizeSwatchBackgroundForLogo(customBg);
    }

    // 2) Si no hay metafield custom en la variante, leer swatch visual (Shopify)
    if (!logoColor) {
      const swatchBg = getSelectedSwatchBackground(productInfoEl);
      logoColor = normalizeSwatchBackgroundForLogo(swatchBg);
    }

    // 3) Fallback metafield del producto
    if (!logoColor) {
      const fallbackRaw = getLogoFallbackColor(sectionId);
      logoColor = normalizeSwatchBackgroundForLogo(fallbackRaw) || fallbackRaw;
    }

    if (!logoColor || typeof logoColor !== "string") return;

    const normalized = logoColor.trim();
    if (!normalized) return;

    if (productInfoEl.dataset.lastLogoColorApplied === normalized) return;
    productInfoEl.dataset.lastLogoColorApplied = normalized;

    if (typeof window.changeLogoColor === "function") {
      window.changeLogoColor(normalized);
    } else if (typeof changeLogoColor === "function") {
      changeLogoColor(normalized);
    }
  }

  // ==========================
  // DESCRIPTION BY COLOR
  // ==========================
  function getColorInputValue(productInfoEl) {
    const candidates = productInfoEl.querySelectorAll('input[type="radio"], select');

    for (const el of candidates) {
      if (el.type === "radio" && el.checked) {
        const fieldset = el.closest("fieldset");
        const legendText = fieldset?.querySelector("legend")?.textContent || "";

        if (
          normalizeText(legendText).includes("color") ||
          normalizeText(legendText).includes("colour")
        ) {
          return el.value;
        }
      }

      if (el.tagName === "SELECT") {
        const name = el.getAttribute("name") || "";
        const label =
          productInfoEl.querySelector(`label[for="${el.id}"]`)?.textContent || "";

        if (
          normalizeText(name).includes("color") ||
          normalizeText(name).includes("colour") ||
          normalizeText(label).includes("color") ||
          normalizeText(label).includes("colour")
        ) {
          return el.value;
        }
      }
    }

    return null;
  }

  function getColorMap(sectionId) {
    const scriptEl = document.getElementById(`ColorDescriptions-${sectionId}`);
    if (!scriptEl) return null;

    try {
      let parsed = JSON.parse(scriptEl.textContent);

      if (typeof parsed === "string") {
        parsed = JSON.parse(parsed);
      }

      return parsed && typeof parsed === "object" ? parsed : null;
    } catch (err) {
      console.warn("ColorDescriptions JSON inválido", err);
      return null;
    }
  }

  function getHeartIconHtml(sectionId) {
    const tpl = document.getElementById(`HeartIconTemplate-${sectionId}`);
    return tpl ? tpl.innerHTML.trim() : "";
  }

  function renderTextWithPlaceholders(text, sectionId) {
    const heartIconHtml = getHeartIconHtml(sectionId);

    let html = (text || "").toString();
    html = html.replaceAll("heartIcon", heartIconHtml);

    const looksLikeHtml = /<[^>]+>/.test(html);
    return looksLikeHtml ? html : `<p>${html}</p>`;
  }

  function updateDescription(productInfoEl) {
    const sectionId = productInfoEl.dataset.section;
    if (!sectionId) return;

    const container = productInfoEl.querySelector(`#VariantAwareDescription-${sectionId}`);
    if (!container) return;

    const colorMap = getColorMap(sectionId);
    if (!colorMap) return;

    if (!container.dataset.originalHtml) {
      container.dataset.originalHtml = container.innerHTML;
    }

    const selectedColor = getColorInputValue(productInfoEl);
    if (!selectedColor) {
      if (container.innerHTML !== container.dataset.originalHtml) {
        container.innerHTML = container.dataset.originalHtml;
      }
      return;
    }

    const selectedNormalized = normalizeText(selectedColor);

    let match = null;
    for (const [key, value] of Object.entries(colorMap)) {
      if (normalizeText(key) === selectedNormalized) {
        match = value;
        break;
      }
    }

    if (typeof match === "string" && match.trim() !== "") {
      const nextHtml = renderTextWithPlaceholders(match, sectionId);
      if (container.innerHTML !== nextHtml) {
        container.innerHTML = nextHtml;
      }
    } else {
      if (container.innerHTML !== container.dataset.originalHtml) {
        container.innerHTML = container.dataset.originalHtml;
      }
    }
  }

  // ==========================
  // RUNNERS
  // ==========================
  function runVariantUIUpdates(productInfoEl) {
    // 1) Pinta TODOS los swatches de color (evita bug visual de “se pega” el gradiente)
    applyCustomGradientToAllColorSwatches(productInfoEl);

    // 2) Actualiza descripción por color
    updateDescription(productInfoEl);

    // 3) Actualiza logo/botón (prioriza metafield de variante)
    updateLogoColorWithVariantFallback(productInfoEl);
  }

  /**
   * Dawn actualiza variante + DOM de forma asíncrona.
   * Reintentamos unas veces para capturar el estado final.
   */
  function runVariantUIUpdatesWithRetries(productInfoEl, retries = 5, delay = 80) {
    let count = 0;

    function tick() {
      if (!document.body.contains(productInfoEl)) return;
      runVariantUIUpdates(productInfoEl);
      count += 1;
      if (count < retries) {
        setTimeout(tick, delay);
      }
    }

    tick();
  }

  // ==========================
  // BIND + INIT
  // ==========================
  function bindProductInfo(productInfoEl) {
    if (!productInfoEl || productInfoEl.dataset.colorDescBound === "true") return;
    productInfoEl.dataset.colorDescBound = "true";

    // Inicial
    setTimeout(() => {
      runVariantUIUpdatesWithRetries(productInfoEl, 4, 70);
    }, 50);

    // Cuando cambian variantes (radios/selects)
    productInfoEl.addEventListener("change", function (event) {
      const target = event.target;
      if (!target) return;

      if (target.matches('input[type="radio"], select')) {
        // Ejecutar inmediato + reintentos (por si Dawn repinta después)
        runVariantUIUpdates(productInfoEl);
        runVariantUIUpdatesWithRetries(productInfoEl, 6, 80);
      }
    });

    // Dawn a veces cambia URL ?variant=...
    window.addEventListener("popstate", function () {
      runVariantUIUpdatesWithRetries(productInfoEl, 6, 80);
    });

    // Extra: detectar cambio real del input hidden de variante (muy útil en Dawn)
    const hiddenVariantInput = productInfoEl.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (hiddenVariantInput) {
      let lastValue = hiddenVariantInput.value;

      const observer = new MutationObserver(() => {
        const current = hiddenVariantInput.getAttribute("value") || hiddenVariantInput.value;
        if (current !== lastValue) {
          lastValue = current;
          runVariantUIUpdatesWithRetries(productInfoEl, 5, 70);
        }
      });

      observer.observe(hiddenVariantInput, {
        attributes: true,
        attributeFilter: ["value"]
      });

      // Backup polling corto para cambios via property (cuando no muta attribute)
      const intervalId = setInterval(() => {
        if (!document.body.contains(productInfoEl)) {
          clearInterval(intervalId);
          observer.disconnect();
          return;
        }

        if (hiddenVariantInput.value !== lastValue) {
          lastValue = hiddenVariantInput.value;
          runVariantUIUpdatesWithRetries(productInfoEl, 5, 70);
        }
      }, 250);
    }
  }

  function init() {
    document.querySelectorAll("product-info").forEach(bindProductInfo);
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();